module.exports = __webpack_public_path__ + "img/android-ios.ba092bc6.svg";